module.exports = __webpack_public_path__ + "img/theater-screen-node.d5119cd.png";